import streetComponent from './street.component';

const streetModule = angular.module('street', [
])
  .component('street', streetComponent)
  .name;

export default streetModule;
